@import "../../variables.scss";

.bookings {
  &__wrapper {
    @media (max-width: 576px) {
      margin: 0 -15px 0 -15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100vw;
      overflow-y: hidden;
    }
  }

  &__showPast {
    background-color: $color-grey;
    color: white;
    width: 200px;
    height: 40px;
    &:hover {
      color: white;
    }
  }

  &__searchAmount {
    margin-top: 3px;
    margin-bottom: 2rem;
  }

  &__emptySearch {
    color: $color-light-grey;
  }
}
